import { useEffect, useState } from "react";
import { Button, Flex, message, Modal, Spin, Switch, Table } from "antd";
import { GRANT_ACCESS_PAGE, SERVER_BASE_URL } from "../config";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "../components/Dropdown";
import { set_OrgIntegratedToZoho } from "../features/ConfigSlice";
import { API } from "../config/auth";

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let searchParams = new URLSearchParams(location.search);

  const [usersList, setUsersList] = useState({
    org_users: [],
    jas_users: [],
    zoho_users: [],
  });
  const [modelOpen, setModelOpen] = useState({
    open: false,
    jas_user: "",
    zoho_user: "",
    error: false,
    error_msg: "",
  });
  const [triggerReloadinUserList, setTriggerReloadinUserList] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const columns = [
    {
      title: "Name",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Ext No",
      dataIndex: "extension_number",
      key: "extension_number",
    },
    {
      title: "Enable/Disable",
      render: (_, record) => (
        <>
          <Switch
            checked={record?.is_integrated_with_zoho}
            onClick={() => {
              integrateUserToZoho("disable", record?.email);
            }}
            disabled={record?.is_integrated_with_zoho === false}
            size="small"
          />
        </>
      ),
    },
  ];

  const dispatch = useDispatch();

  const isOrgIntegratedToZoho = useSelector(
    (state) => state.config?.is_org_integrated_to_zoho
  );

  console.log(isOrgIntegratedToZoho);

  const organization_id = useSelector((state) => state.config.organization_id);

  async function integrationWithZohoAPI() {
    // setData((prev) => ({ ...prev, loading: true }));

    let body = {
      organization_id: searchParams.get("state"),
      update_type: "auth_details",
      updates: {
        auth_type: "ZOHO",
        auth_code: searchParams.get("code"),
        datacenter: searchParams.get("location"),
      },
    };

    await API.patch(`${SERVER_BASE_URL}/organization/update_organization`, body)
      .then((response) => {
        if (response.data?.success === false) {
          return message.error("Please try again later!!");
        }

        window.localStorage.setItem("is_org_integrated_to_zoho", true);
        dispatch(set_OrgIntegratedToZoho(true));

        const url = window.location.href;
        window.history.replaceState(null, "", url);
      })
      .finally(() => {
        // setData((prev) => ({ ...prev, loading: false }));
      });
  }

  async function fetchUserList() {
    setLoading(true);
    await API.post(`${SERVER_BASE_URL}/user/user_list`, {
      organization_id: organization_id,
      required_list: ["zoho_users", "jas_users", "org_users"],
    })
      .then((response) => {
        if (response?.data?.success === false) {
          if (response?.data?.message === "Need to integrate with Zoho") {
            window.localStorage.setItem("is_org_integrated_to_zoho", false);
            dispatch(set_OrgIntegratedToZoho(false));
            return;
          }

          if (response?.data?.message === "Invalid 'organization_id' found!!") {
            navigate("/login");
            // notification.error("Error occured!!");
            return;
          }
        }
        console.log(response.data);
        setUsersList(response?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (isOrgIntegratedToZoho) {
      console.log(isOrgIntegratedToZoho);

      fetchUserList();
    }
  }, [isOrgIntegratedToZoho, triggerReloadinUserList]);

  useEffect(() => {
    if (searchParams.get("state") && searchParams.get("code")) {
      console.log(searchParams.get("state"), searchParams.get("code"));

      integrationWithZohoAPI();
    }
  }, []);

  const integrateUserToZoho = async (action_type, jas_email) => {
    if (action_type !== "disable") {
      if (!modelOpen?.jas_user || !modelOpen?.zoho_user) return;
    }

    //checks the user is already integrated to zoho
    if (Array.isArray(usersList.org_users) && usersList.org_users?.length) {
      let org_user = usersList?.org_users?.filter(
        (user) => user?.email === modelOpen?.jas_user
      );

      if (
        Array.isArray(org_user) &&
        org_user.length &&
        action_type !== "disable"
      ) {
        if (org_user[0]?.is_integrated_with_zoho) {
          setModelOpen({
            ...modelOpen,
            error: true,
            error_msg: "This user is already integrated to Zoho",
          });
          return;
        }
      }
    }

    let username = usersList?.jas_users?.filter(
      (user) => user?.email === modelOpen?.jas_user
    )[0]?.first_name;
    let zoho_user_id = usersList?.zoho_users?.filter(
      (user) => user?.email === modelOpen?.zoho_user
    )[0]?.zohouser;
    let extension_number = usersList?.jas_users?.filter(
      (user) => user?.email === modelOpen?.jas_user
    )[0]?.ext_no;

    if (action_type === "disable") setLoading(true);
    else setBtnLoading(true);

    const body = {
      organization_id: organization_id,
      email: jas_email ? jas_email : modelOpen?.jas_user,
      action_type: action_type,
      username: username,
      zoho_user_id: zoho_user_id,
      extension_number: extension_number,
    };

    await API.post(`${SERVER_BASE_URL}/user/integrate_user_to_zoho`, body)
      .then((response) => {
        console.log(response.data);
        if (response?.data?.success) {
          if (action_type === "enable") {
            setModelOpen({
              open: false,
              jas_user: "",
              zoho_user: "",
              error: false,
              error_msg: "",
            });
          }
          // let org_users = [...usersList?.org_users];
          // org_users = org_users.map((user)=>{
          //   if(user?.email === jas_email ? jas_email : modelOpen?.jas_user ){
          //     return {
          //       ...
          //     }
          //   }
          // })
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        console.log("finally");

        setLoading(false);
        setBtnLoading(false);
        setTriggerReloadinUserList(!triggerReloadinUserList);
      });
  };

  return (
    <div>
      <Modal
        onCancel={() => {
          setModelOpen((prev) => ({ ...prev, open: false }));
        }}
        open={modelOpen?.open}
        title="Integrate User To Zoho"
        footer={false}
        centered
        maskClosable={false}
      >
        <br />
        <Flex vertical gap={16}>
          <Dropdown
            label="Select the JAS User"
            options={usersList?.jas_users.map((item) => {
              return {
                key: item?.ext_no,
                value: item?.email,
                label: `${item?.ext_no} - ${item?.email}`,
              };
            })}
            value={modelOpen?.jas_user}
            onChange={(value) => {
              setModelOpen((prev) => ({ ...prev, jas_user: value }));
            }}
          />
          <Dropdown
            label="Select the Zoho User"
            options={usersList?.zoho_users.map((item) => {
              return {
                key: item?.zohouser,
                value: item?.email,
                label: `${item?.username} - ${item?.email}`,
              };
            })}
            value={modelOpen?.zoho_user}
            onChange={(value) => {
              setModelOpen((prev) => ({ ...prev, zoho_user: value }));
            }}
          />

          {modelOpen?.error ? (
            <p style={{ color: "red" }}>{modelOpen?.error_msg}</p>
          ) : (
            ""
          )}

          <div></div>
          <Flex align="center" gap={16} justify="center">
            <Button
              type="primary"
              onClick={() => integrateUserToZoho("enable")}
              loading={btnLoading}
              disabled={!modelOpen?.jas_user || !modelOpen?.zoho_user}
            >
              Assign
            </Button>
            <Button
              onClick={() => {
                setModelOpen((prev) => ({ ...prev, open: false }));
              }}
            >
              Cancel
            </Button>
          </Flex>
        </Flex>
      </Modal>

      {loading ? (
        <Flex
          align="center"
          justify="center"
          className="dashboard_spin_container"
        >
          <Spin spinning={loading} />
        </Flex>
      ) : isOrgIntegratedToZoho ? (
        <div className="user_table_container">
          <Flex justify="end">
            <Button
              type="primary"
              onClick={() => {
                setModelOpen((prev) => ({ ...prev, open: true }));
              }}
            >
              Integrate User To Zoho
            </Button>
          </Flex>
          <br />
          <Table
            columns={columns}
            dataSource={usersList?.org_users}
            style={{ width: "700px" }}
            pagination={false}
          />
        </div>
      ) : (
        <div className="db_not_in_cont">
          <h2>JAS x ZOHO</h2>

          <br />

          <p>
            To integrate JAS communications with Zoho for telephone services,
            please click the <b>Integrate</b> button below:
          </p>

          <br />
          <Button
            type="primary"
            onClick={() => {
              window.open(GRANT_ACCESS_PAGE(organization_id));
            }}
          >
            Integrate
          </Button>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
